// Data + category style helpers for the Katha (Divine Videos) page.
// Kept separate so cards/filters can be reused without duplicating this config.

export const topVideosData = [
  {
    id: 1,
    title: "Divine Birth of Lord Krishna",
    category: "katha",
    duration: "45:30",
    views: "25K",
    thumbnail: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    youtubeId: "AGjx27_87iY"
  },
  {
    id: 2,
    title: "Morning Pravachan: Inner Peace",
    category: "pravachan",
    duration: "28:15",
    views: "18K",
    thumbnail: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    youtubeId: "AGjx27_87iY"
  },
  {
    id: 3,
    title: "Divine Bhajan Evening",
    category: "bhajan",
    duration: "1:15:20",
    views: "22K",
    thumbnail: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    youtubeId: "AGjx27_87iY"
  },
  {
    id: 4,
    title: "Hanuman's Devotion Story",
    category: "katha",
    duration: "52:10",
    views: "30K",
    thumbnail: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    youtubeId: "AGjx27_87iY"
  },
  {
    id: 5,
    title: "Live Temple Ceremony",
    category: "live",
    duration: "2:30:45",
    views: "45K",
    thumbnail: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    youtubeId: "AGjx27_87iY"
  },
  {
    id: 6,
    title: "Quick Spiritual Wisdom",
    category: "shorts",
    duration: "0:45",
    views: "12K",
    thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    youtubeId: "AGjx27_87iY"
  }
];

export const playlistsData = [
  {
    id: 1,
    name: "Shrimad Bhagvat Katha",
    category: "katha",
    videoCount: 25,
    thumbnail: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    playlistUrl: "https://youtube.com/playlist?list=PLrAXtmRdnEQeiGGw1BmBVVgL8XcN3WwKN",
    featured: true
  },
  {
    id: 2,
    name: "Ram Katha Series",
    category: "katha",
    videoCount: 18,
    thumbnail: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    playlistUrl: "https://youtube.com/playlist?list=PLrAXtmRdnEQeiGGw1BmBVVgL8XcN3WwKN",
    featured: false
  },
  {
    id: 3,
    name: "Divine Bhajan Collection",
    category: "bhajan",
    videoCount: 35,
    thumbnail: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    playlistUrl: "https://youtube.com/playlist?list=PLrAXtmRdnEQeiGGw1BmBVVgL8XcN3WwKN",
    featured: true
  },
  {
    id: 4,
    name: "Evening Bhajan Sessions",
    category: "bhajan",
    videoCount: 22,
    thumbnail: "https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    playlistUrl: "https://youtube.com/playlist?list=PLrAXtmRdnEQeiGGw1BmBVVgL8XcN3WwKN",
    featured: false
  },
  {
    id: 5,
    name: "Daily Pravachan",
    category: "pravachan",
    videoCount: 50,
    thumbnail: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    playlistUrl: "https://youtube.com/playlist?list=PLrAXtmRdnEQeiGGw1BmBVVgL8XcN3WwKN",
    featured: true
  },
  {
    id: 6,
    name: "Spiritual Discourses",
    category: "pravachan",
    videoCount: 28,
    thumbnail: "https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    playlistUrl: "https://youtube.com/playlist?list=PLrAXtmRdnEQeiGGw1BmBVVgL8XcN3WwKN",
    featured: false
  },
  {
    id: 7,
    name: "Live Events & Ceremonies",
    category: "live",
    videoCount: 20,
    thumbnail: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    playlistUrl: "https://youtube.com/playlist?list=PLrAXtmRdnEQeiGGw1BmBVVgL8XcN3WwKN",
    featured: false
  },
  {
    id: 8,
    name: "Meditation & Yoga",
    category: "meditation",
    videoCount: 15,
    thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    playlistUrl: "https://youtube.com/playlist?list=PLrAXtmRdnEQeiGGw1BmBVVgL8XcN3WwKN",
    featured: false
  }
];

/** Preferred display order for category chips */
export const CATEGORY_ORDER = ['katha', 'pravachan', 'bhajan', 'live', 'shorts', 'meditation'];

/** Labels for video filter chips */
export const VIDEO_CATEGORY_LABELS = {
  katha: 'Katha Stories',
  pravachan: 'Pravachan',
  bhajan: 'Bhajans',
  live: 'Live Events',
  shorts: 'Shorts',
  meditation: 'Meditation & Yoga',
};

/** Labels for playlist filter chips */
export const PLAYLIST_CATEGORY_LABELS = {
  katha: 'Katha Series',
  pravachan: 'Pravachan Series',
  bhajan: 'Bhajan Collections',
  live: 'Live Events',
  shorts: 'Shorts',
  meditation: 'Meditation & Yoga',
};

/**
 * Build filter chips from items' categories (unique values present in data).
 * @param {Array<{category?: string}>} items
 * @param {{ allLabel?: string, labels?: Record<string, string>, order?: string[] }} options
 */
export const buildCategoryFilters = (
  items,
  { allLabel = 'All', labels = VIDEO_CATEGORY_LABELS, order = CATEGORY_ORDER } = {}
) => {
  const present = new Set(
    (items || [])
      .map((item) => (item.category || '').trim().toLowerCase())
      .filter(Boolean)
  );

  const ordered = (order || []).filter((c) => present.has(c));
  // Include any unknown categories from API at the end
  present.forEach((c) => {
    if (!ordered.includes(c)) ordered.push(c);
  });

  return [
    { val: 'all', label: allLabel },
    ...ordered.map((val) => ({
      val,
      label: labels[val] || val.charAt(0).toUpperCase() + val.slice(1),
    })),
  ];
};

/** @deprecated Prefer buildCategoryFilters from live data */
export const videoCategoryFilters = [
  { val: 'all', label: 'All Videos' },
  ...CATEGORY_ORDER.filter((c) => VIDEO_CATEGORY_LABELS[c]).map((val) => ({
    val,
    label: VIDEO_CATEGORY_LABELS[val],
  })),
];

/** @deprecated Prefer buildCategoryFilters from live data */
export const playlistFilters = [
  { val: 'all', label: 'All Collections' },
  ...CATEGORY_ORDER.filter((c) => PLAYLIST_CATEGORY_LABELS[c] && c !== 'shorts').map((val) => ({
    val,
    label: PLAYLIST_CATEGORY_LABELS[val],
  })),
];

export const getPlaylistDescription = (name) => {
  if (name.includes('Bhagvat')) return 'Divine stories from Shrimad Bhagavatam with spiritual insights and teachings for spiritual growth.';
  if (name.includes('Ram')) return 'Sacred stories of Lord Rama\'s divine journey and teachings from the holy Ramayana.';
  if (name.includes('Bhajan')) return 'Beautiful devotional songs and bhajans for spiritual upliftment and divine connection.';
  if (name.includes('Pravachan')) return 'Daily spiritual discourses and teachings for continuous spiritual growth and wisdom.';
  if (name.includes('Live')) return 'Live spiritual events, ceremonies, and special occasions from our sacred temple.';
  if (name.includes('Meditation')) return 'Guided meditation sessions and yoga practices for inner peace and spiritual wellness.';
  return 'Spiritual content for your divine journey and inner transformation.';
};

// Tailwind CDN v2 has no orange-* utilities — mirror other colors with matching hex steps.
export const categoryStyles = {
  orange: {
    card: 'border',
    cardStyle: {
      background: 'linear-gradient(to bottom right, #ffffff, #fff7ed)', // white → orange-50
      borderColor: '#ffedd5', // orange-100
    },
    cardHoverBorder: '#fdba74', // orange-300
    accent: '',
    title: '',
    titleHover: '#ea580c', // orange-600
    icon: '',
    iconColor: '#f97316', // orange-500
    tag: '',
    tagStyle: { background: '#ffedd5', color: '#c2410c' }, // orange-100 / orange-700
    button: '',
    gradient: 'linear-gradient(to right, #f97316, #ea580c)', // orange-500 → orange-600
    gradientHover: 'linear-gradient(to right, #ea580c, #c2410c)', // orange-600 → orange-700
  },
  pink: {
    card: 'bg-gradient-to-br from-white to-pink-50 border-pink-100 hover:border-pink-300',
    accent: 'bg-gradient-to-r from-pink-500 to-pink-600',
    title: 'group-hover:text-pink-600',
    icon: 'text-pink-500',
    tag: 'bg-pink-100 text-pink-700',
    button: 'bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700',
  },
  purple: {
    card: 'bg-gradient-to-br from-white to-purple-50 border-purple-100 hover:border-purple-300',
    accent: 'bg-gradient-to-r from-purple-500 to-purple-600',
    title: 'group-hover:text-purple-600',
    icon: 'text-purple-500',
    tag: 'bg-purple-100 text-purple-700',
    button: 'bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700',
  },
  red: {
    card: 'bg-gradient-to-br from-white to-red-50 border-red-100 hover:border-red-300',
    accent: 'bg-gradient-to-r from-red-500 to-red-600',
    title: 'group-hover:text-red-600',
    icon: 'text-red-500',
    tag: 'bg-red-100 text-red-700',
    button: 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700',
  },
  green: {
    card: 'bg-gradient-to-br from-white to-green-50 border-green-100 hover:border-green-300',
    accent: 'bg-gradient-to-r from-green-500 to-green-600',
    title: 'group-hover:text-green-600',
    icon: 'text-green-500',
    tag: 'bg-green-100 text-green-700',
    button: 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700',
  },
  blue: {
    card: 'bg-gradient-to-br from-white to-blue-50 border-blue-100 hover:border-blue-300',
    accent: 'bg-gradient-to-r from-blue-500 to-blue-600',
    title: 'group-hover:text-blue-600',
    icon: 'text-blue-500',
    tag: 'bg-blue-100 text-blue-700',
    button: 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700',
  },
};

export const getCategoryMeta = (category) => {
  switch (category) {
    case 'katha':
      return { icon: 'fas fa-book-open', name: 'Katha', styles: categoryStyles.orange };
    case 'bhajan':
      return { icon: 'fas fa-music', name: 'Bhajan', styles: categoryStyles.pink };
    case 'pravachan':
      return { icon: 'fas fa-microphone', name: 'Pravachan', styles: categoryStyles.purple };
    case 'live':
      return { icon: 'fas fa-broadcast-tower', name: 'Live', styles: categoryStyles.red };
    case 'shorts':
      return { icon: 'fas fa-bolt', name: 'Shorts', styles: categoryStyles.green };
    case 'meditation':
      return { icon: 'fas fa-om', name: 'Meditation', styles: categoryStyles.blue };
    default:
      return { icon: 'fas fa-list', name: 'Katha', styles: categoryStyles.red };
  }
};

// Spread items so neighboring cards avoid the same category/color when possible.
export const interleaveByCategory = (items) => {
  if (!items || items.length <= 1) return items || [];

  const queues = new Map();
  items.forEach((item) => {
    const key = item.category || 'default';
    if (!queues.has(key)) queues.set(key, []);
    queues.get(key).push(item);
  });

  // Single category filter — nothing to interleave
  if (queues.size === 1) return items;

  const result = [];
  let lastCategory = null;

  while (result.length < items.length) {
    let picked = false;

    for (const [category, queue] of queues) {
      if (!queue.length || category === lastCategory) continue;
      result.push(queue.shift());
      lastCategory = category;
      picked = true;
      break;
    }

    // Fallback if only remaining items share lastCategory
    if (!picked) {
      for (const [, queue] of queues) {
        if (!queue.length) continue;
        result.push(queue.shift());
        lastCategory = result[result.length - 1].category || 'default';
        break;
      }
    }
  }

  return result;
};
